/* eslint-disable */
import { useEffect } from "react";

export const useInitTemplate = () => {
 useEffect(() => {
   const timer = setTimeout(() => {
     const $ = window.jQuery;
     const gsap = window.gsap;
     const Swiper = window.Swiper;

     if (!$) return;

     // --- 1. FIXED PROGRESS BARS ---
     if ($(".count-bar").length) {
       $(".count-bar").appear(
         function () {
           var el = $(this);
           var percent = el.data("percent");
           $(el).css("width", percent);
           $(el).find(".count-text").html(percent);
         },
         { accY: 0 },
       );
     }

     // --- 2. BANNER SLIDER ---
     if ($(".banner-slider").length && Swiper) {
       if ($(".banner-slider")[0].swiper)
         $(".banner-slider")[0].swiper.destroy();
       new Swiper(".banner-slider", {
         loop: true,
         autoplay: { delay: 5000, disableOnInteraction: false },
         speed: 1000,
         effect: "fade",
         pagination: { el: ".swiper-pagination", clickable: true },
         navigation: {
           nextEl: ".swiper-button-next",
           prevEl: ".swiper-button-prev",
         },
       });
     }

     // --- 3. GSAP ---
     if (gsap) {
       gsap.registerPlugin(window.ScrollTrigger, window.SplitText);
     }

     // --- 4. WOW.js ---
     if (window.WOW) {
       new window.WOW().init();
     }

     // --- 5. SERVICE SLIDER ---
     if ($(".service-slider").length && Swiper) {
       if ($(".service-slider")[0].swiper)
         $(".service-slider")[0].swiper.destroy();
       new Swiper(".service-slider", {
         slidesPerView: 3,
         spaceBetween: 30,
         loop: true,
         autoplay: { delay: 4000, disableOnInteraction: false },
         pagination: { el: ".service-pagination", clickable: true },
         breakpoints: {
           320: { slidesPerView: 1 },
           768: { slidesPerView: 2 },
           1024: { slidesPerView: 3 },
         },
       });
     }

     // Mobile nav toggler is wired up globally in MainLayout.jsx instead of
     // here, since it needs to work on every page, not just Home.

  // --- 7. BRAND SLIDER (LINEAR TICKER MODE) ---
if ($(".brand-slider").length && window.Swiper) {
  const sliderEl = $(".brand-slider")[0];

  if (sliderEl.swiper) {
    sliderEl.swiper.destroy(true, true);
  }

  const brandSwiper = new window.Swiper(".brand-slider", {
    slidesPerView: 2,
    spaceBetween: 30,
    loop: true,
    freeMode: true,
    speed: 5000,

    allowTouchMove: false,
    simulateTouch: false,

    autoplay: {
      delay: 0,
      disableOnInteraction: false,
    },

    breakpoints: {
      480: { slidesPerView: 2 },
      768: { slidesPerView: 3 },
      1024: { slidesPerView: 4 },
      1200: { slidesPerView: 5 },
    },
  });

  $(".brand-slider").on("mouseenter", function () {
    brandSwiper.autoplay.stop();
  });

  $(".brand-slider").on("mouseleave", function () {
    brandSwiper.autoplay.start();
  });

  $(".brand-slider").on("click touchstart", function (e) {
    e.preventDefault();
    brandSwiper.autoplay.start();
  });
}
   }, 500);

   return () => clearTimeout(timer);
 }, []);
};